'use strict';

// picturefill isn't an es6 module, so grab everything as picturefill
import * as picturefill from 'picturefill';

// invoke picturefill globally before anything
picturefill();

// URLSearchParams will self-invoke if required
import 'url-search-params-polyfill';

// Promise polyfill for Opera & co.
import 'promise-polyfill/src/polyfill';

// our polyfills will self-invoke if required
import 'utils/polyfills';

// modules will invoke themselves
import { init as spotlight } from 'modules/spotlight';
import { init as toggle } from 'modules/toggle';
import { init as videoResize } from 'modules/video-resize';
import { init as tabbing } from 'modules/tabbing';
import { init as globalNavigation } from 'modules/global-navigation';
import { init as messages } from 'modules/messages';
import { init as scroller } from 'modules/scroller';
import { init as inlineModal} from 'modules/inline-modal';
import { init as scrollTo } from 'modules/scroll-to';
import { init as imageGallery } from 'modules/image-gallery';
import { init as accordion } from 'modules/accordion';
import { init as donate } from 'modules/donate';
import { init as videoModal } from 'modules/video-modal';
import { init as fadeGallery } from 'modules/fade-gallery';
import { init as forms } from 'modules/forms';
import { init as favoritesModalObserver } from 'modules/favoritesModalObserver';
import { init as newsletter } from 'modules/newsletter';
import { init as userStatus } from 'modules/user-status';
import { init as cartStatus } from 'modules/cart-status';
import { init as favoritesStatus } from 'modules/favorites-status';
import { init as newsList } from 'modules/news-list';
import { init as infiniteScroll } from 'modules/infinite-scroll';
import { init as search } from 'modules/search';
import { init as concertNav } from 'modules/concert-nav';
import { init as concertStickyBtn } from 'modules/concert-sticky-btn';
import { init as backgroundVideo } from 'modules/background-video';
import { init as dialog } from 'modules/dialog';
import { init as navPopup } from 'modules/nav-popup';
import { init as performanceModal } from 'modules/performance-modal';

// Vue widgets
import './widgets/bootstrap';

window.addEventListener('load', function () {
    spotlight();
    toggle();
    scroller();
    videoResize();
    tabbing();
    globalNavigation();
    messages();
    inlineModal();
    scrollTo();
    imageGallery();
    accordion();
    donate();
    videoModal();
    fadeGallery();
    forms();
    favoritesModalObserver();
    newsletter();
    userStatus();
    cartStatus();
    favoritesStatus();
    newsList();
    infiniteScroll();
    search();
    concertNav();
    concertStickyBtn();
    backgroundVideo();
    dialog();
    navPopup();
    performanceModal();
});
